<microsec-form-builder #fb [fields]="fields" [isPage]="true" [submitButtonLabel]="SAVE_CHANGES_LABEL" [shouldShowActionButtons]="false" />

<ng-template #criticalityField>
  @if (!!form && !!form.form) {
    <ng-container [formGroup]="form.form">
      <div class="flex items-center w-full">
        <div class="flex grow">
          <p-slider class="w-full" [formControlName]="DEVICE_FORM_PARAMS.CRITICALITY" [min]="0" [max]="10" />
        </div>
        <div class="flex grow-0 w-[50px] justify-center">
          <label class="font-bold">
            {{ form.getControlValue(DEVICE_FORM_PARAMS.CRITICALITY) }}
          </label>
        </div>
      </div>
    </ng-container>
  }
</ng-template>

<ng-template #tagsField>
  <app-tags-field
    [disableState]="!form.getControlValue(DEVICE_FORM_PARAMS.TAGS + '_toggle') || false"
    [(selectedTags)]="selectedTags"
    fieldName="tag" />
</ng-template>

<ng-template #zonesField>
  <app-tags-field
    [disableState]="!form.getControlValue(DEVICE_FORM_PARAMS.ZONES + '_toggle') || false"
    [(selectedTags)]="selectedZones"
    fieldName="zone" />
</ng-template>
